export const LEGEND_CONTAINER_WIDTH = ["100%", "345px", "285px", "430px"];
